import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import get from 'lodash.get';
import SV from 'server-vars';

import { trackEcommerce, trackEvent, trackingConstants, eventNameConstants } from 'dibs-tracking';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { Carousel } from 'dibs-carousel';
import { ContemporaryLandingProductsModuleItem } from './ContemporaryLandingProductsModuleItem';
import { SharedCarouselDot } from '../../sharedComponents/SharedCarouselDot/SharedCarouselDot';

import styles from './ContemporaryLandingProductsModule.scss';

const NUM_ITEMS_PER_ROW = 4;

class ContemporaryLandingProductsModuleComponent extends Component {
    constructor(props) {
        super(props);

        this.state = { trackingHasFired: { 0: true } };

        this.handleClick = this.handleClick.bind(this);
        this.trackInitialClick = this.trackInitialClick.bind(this);
        this.trackRecurringClick = this.trackRecurringClick.bind(this);
    }

    componentDidMount() {
        this.trackRecurringClick({ rowIndex: 0 });
    }

    trackInitialClick() {
        trackEvent({
            category: 'contemporary landing page interaction',
            action: 'featured items',
            label: 'featured item nav clicked',
        });
    }

    trackRecurringClick({ rowIndex }) {
        const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
        const productRow = get(this.props, 'contemporaryLandingRow.items' || []).filter(
            item => item.type === 'productRow'
        );
        const items = productRow[rowIndex].items || [];
        const products = items.map(item => ({
            brand: get(item, 'brand'),
            category: '/contemporary',
            dimension76: isUserTypeTrade ? 'net price' : 'list price',
            dimension83: get(item, 'contemporaryTrackingString'),
            id: get(item, 'itemPk'),
            list: "editors' picks",
            name: get(item, 'title'),
            position: rowIndex + 1,
            price: isUserTypeTrade ? get(item, 'retailPrice') : get(item, 'netprice'),
        }));
        const { ECOM_PRODUCT_IMPRESSION } = trackingConstants;
        const { EVENT_VIEW_ITEM_LIST } = eventNameConstants;

        trackEcommerce({
            type: ECOM_PRODUCT_IMPRESSION,
            eventName: EVENT_VIEW_ITEM_LIST,
            products,
        });
    }

    handleClick({ index }) {
        const { trackingHasFired } = this.state;
        const rowIndex = Math.floor(index / NUM_ITEMS_PER_ROW);
        if (trackingHasFired[rowIndex]) {
            this.trackInitialClick();
        } else {
            this.trackRecurringClick({ rowIndex });
            this.setState({ trackingHasFired: { ...trackingHasFired, [rowIndex]: true } });
        }
    }

    render() {
        const { contemporaryLandingRow, showSwiper } = this.props;

        if (!contemporaryLandingRow || !contemporaryLandingRow.items) {
            return null;
        }

        const productRows = contemporaryLandingRow.items.filter(item => item.type === 'productRow');
        const items = productRows.reduce((acc, productRow) => {
            acc = acc.concat(productRow.items);
            return acc;
        }, []);
        const carouselClasses = { item: styles.item };

        return (
            <div className={styles.wrapper}>
                <BarHeader title={get(contemporaryLandingRow, 'items[0].text')} />
                <Carousel
                    dataTn="hero-items-carousel"
                    classNames={
                        showSwiper ? { ...carouselClasses, list: styles.swiper } : carouselClasses
                    }
                    showDots={!showSwiper}
                    hideArrows
                    totalItems={items.length}
                    itemsPerPage={showSwiper ? 2.5 : NUM_ITEMS_PER_ROW}
                    slideCarouselItems
                    step={NUM_ITEMS_PER_ROW}
                    renderItem={({ index }) => (
                        <ContemporaryLandingProductsModuleItem item={items[index]} />
                    )}
                    onIndexChange={this.handleClick}
                    renderDot={({ isCurrentDot } = {}) => (
                        <SharedCarouselDot isActive={isCurrentDot} />
                    )}
                />
            </div>
        );
    }
}

ContemporaryLandingProductsModuleComponent.defaultProps = {
    showSwiper: false,
};

ContemporaryLandingProductsModuleComponent.propTypes = {
    contemporaryLandingRow: PropTypes.object,
    showSwiper: PropTypes.bool.isRequired,
};

export const ContemporaryLandingProductsModule = createFragmentContainer(
    ContemporaryLandingProductsModuleComponent,
    {
        contemporaryLandingRow: graphql`
            fragment ContemporaryLandingProductsModule_contemporaryLandingRow on ContemporaryLandingRow {
                ... on ContemporaryLandingRow {
                    items {
                        ... on ContemporaryLandingHeader {
                            text
                            type
                        }
                        ... on ContemporaryLandingRow {
                            items {
                                ... on ContemporaryLandingProductRowItem {
                                    brand
                                    contemporaryTrackingString
                                    imagePath
                                    itemPk
                                    link
                                    netPrice
                                    retailPrice
                                    title
                                }
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
